/**
 * @license Copyright © HatioLab Inc. All rights reserved.
 */

import './ox-editor-board-selector.js'

import { html, TemplateResult } from 'lit'
import { customElement } from 'lit/decorators.js'

import { OxPropertyEditor, PropertySpec } from '@operato/property-editor'

@customElement('ox-property-editor-board-selector')
class PropertyEditorBoardSelector extends OxPropertyEditor {
  static get styles() {
    return [...OxPropertyEditor.styles]
  }

  editorTemplate(value: any, spec: PropertySpec): TemplateResult {
    return html`
      <ox-editor-board-selector id="editor" .value=${value} .properties=${spec.property}></ox-editor-board-selector>
    `
  }
}
